import { GroupVisitSession, GroupVisitSessionControllerApi } from "@/services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "@/utils/utils";

type Params = {
  groupVisitId: string;
  session: GroupVisitSession;
};

export const useScheduleGroupSession = () =>
  useMutationWithLoading(async ({ groupVisitId, session }: Params) =>
    new GroupVisitSessionControllerApi(getConfigObject()).scheduleSession(
      groupVisitId,
      session,
      getXtenantId()
    )
  );
